export const events = {
  SCENARIO_ORDER: 'uf.scenarios.reorder',
};
